export default {"src":"/_next/static/media/flag.2104778f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};